import React, { useEffect } from "react";

import { usePageTitle } from "@/atoms/page-title-atom";
import { EditBreakdown } from "@features/breakdown-v2";

export const EditBreakdownPage = () => {
  const [, setPageTitle] = usePageTitle();

  useEffect(() => {
    setPageTitle("Breakdowns / Edit breakdown");
  }, [setPageTitle]);

  return (
    <div className="p-6">
      <EditBreakdown />
    </div>
  );
};
